<div class="animated fadeInRight">
  <!-- MENU DE TITULOS -->
  <app-lfsa-card-v2 [innTemplateButton]="innTemplateButton" [innTemplate]="enviarTemplateEdit" 
    [modulo]="DAT_TITULOS.modulo" [tituloCard]="DAT_TITULOS.tituloCardListar" 
    [titulo]="DAT_TITULOS.titulo">
  </app-lfsa-card-v2>
  <!-- MENU DE TITULOS -->

  <!-- OPCIONES LATERAL IZQUIERDO -->
  <ng-template #innTemplateButton>
    <div class="col-md-6 mb-2">
      <div class="pagetitle">
        <div class="btn-group-justified btn-group" style="float: right;">
          <button (click)="nuevoRegistro()" class="btn btn-outline-success">
            <i aria-hidden="true" class="fa fa-plus"></i> {{DAT_BTNS.agregar}}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
  <!-- OPCIONES LATERAL IZQUIERDO -->

  <!-- GRILLA -->
  <ng-template #enviarTemplateEdit>
    <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
    <ag-grid-angular #agGrid (gridReady)="onGridReady($event)" [class]="DAT_AG_GRID.class" [columnDefs]="columnDefs"
                     [floatingFilter]="true" [frameworkComponents]="frameworkComponents" [id]="DAT_AG_GRID.id"
                     [ngStyle]="DAT_AG_GRID.style" [paginationPageSize]="DAT_AG_GRID.paginacion"
                     [pagination]="true"
                     [rowData]="rowData">
    </ag-grid-angular>
  </ng-template>
  <!-- GRILLA -->
</div>

<!-- MODAL -->
<app-lfsa-modal [idButton]="'abrirModal'" [idClose]="'cerrarModal'" [idOpen]="'Modal'" 
  [titulo]="'Mantener Balanzas'" [innTemplate]="abrirModal" >
</app-lfsa-modal>

<ng-template #abrirModal>
  <div class="container-fluid">
    <form [formGroup]="formulario" novalidate class="row form-group" mat-dialog-content>
      <div class="form-group col-md-6">
        <label>Id de Bascula</label>
        <input type="text" class="form-control" id="idBascula" formControlName="idBascula" name="idBascula" readonly>
      </div>

      <div class="form-group col-md-6">
        <app-lfsa-input [claseLabel]="'letrasDefault'" [id]="'ipBalanza'" 
          [label]="'IP Balanza'" [type]="'text'" [placeholder]="'IP Balanza'" 
          [control]="formulario.get('ipBalanza') | formControl" formControlName="ipBalanza" >
        </app-lfsa-input>
        <small>
          <div *ngIf="validIP && !formulario.controls['ipBalanza'].errors">IP ya registrada, no se pernmite duplicar IP.</div>
        </small>
      </div>

      <div class="form-group col-md-12">
        <app-lfsa-input [claseLabel]="'letrasDefault'" [id]="'desca'" 
          [label]="'Descripción de la Balanza'" [type]="'text'" [placeholder]="'Balanza Planta Linea ......'" 
          [control]="formulario.get('desca') | formControl" formControlName="desca" >
        </app-lfsa-input>
      </div>

      <div class="form-group col-md-8">
        <app-lfsa-combo-box [opcion]="'nombre'" [idOpcion]="'id'" [comboBox]="cmbPlanta" formControlName="plantaId"
          [control]="formulario.get('plantaId')" [label]="'Planta'" [id]="'plantaId'" >
        </app-lfsa-combo-box>
      </div>

      <div class="form-group col-md-4">
        <app-lfsa-combo-box [opcion]="'valor'" [idOpcion]="'clave'" [comboBox]="cmbEstado" formControlName="estado" 
          [control]="formulario.get('estado')" [label]="'Estado de la bascula'" [id]="'estado'">
        </app-lfsa-combo-box>
      </div>

      <app-lfsa-botones-formulario (devolverAccion)="acciones( $event )" 
      [formularioValido]="validForm()" [loading]="loading" [textBoton]="'Guardar'" class="row">
      </app-lfsa-botones-formulario>
    </form>
  </div>

</ng-template>
<!-- END MODAL -->